export const STORAGE_KEY = "digitalPortal_monitoramentoPreco_coletas";

export const COLETA_PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const COLETA_PHOTO_TARGET_MAX_BYTES = 1.5 * 1024 * 1024;
export const COLETA_PHOTO_MAX_WIDTH = 1920;
export const COLETA_PHOTO_JPEG_QUALITY = 0.82;

/** Paleta alinhada às referências visuais do formulário (não usa tema do portal). */
export const MP = {
  primary: "#0056b3",
  primaryHover: "#004494",
  primarySoft: "#e8f2fc",
  text: "#1a1d21",
  textMuted: "#5c6570",
  border: "#dde1e6",
  cardBg: "#ffffff",
  pageBg: "#eef2f7",
  tableHead: "#f0f2f5",
  danger: "#c62828",
  radiusLg: 10,
  radiusMd: 8,
  shadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
  font: '"Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};
